import * as React from "react"

function SvgChevronLeft(props) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.617 0a.38.38 0 01.274.117A.402.402 0 016 .4c0 .11-.036.203-.11.281L.897 6.041l4.918 5.267c.073.078.11.174.11.287 0 .114-.037.21-.11.288a.352.352 0 01-.268.117.352.352 0 01-.267-.117L.11 6.323A.398.398 0 010 6.04c0-.11.036-.203.11-.281L5.354.117A.356.356 0 015.481.03.358.358 0 015.617 0z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgChevronLeft
